
    <!--<nav class="navbar navbar-primary bg-primary">
        <span class="navbar-text">
         Computer Science Notes
        </span>
    </nav>-->
    <h1>Computer Science and ICT Notes</h1>
    <div class="row">

      <div class="col-sm">
        <img src="https://cdn.pixabay.com/photo/2020/04/30/17/50/network-5113917_960_720.jpg" alt="Italian Trulli">
       
      </div>
      <div class="col-sm">
        <img src="https://cdn.pixabay.com/photo/2019/08/26/05/21/network-4430786_960_720.jpg" alt="Italian Trulli">
             </div>
      <div class="col-sm">
        <img src="https://d205s6oy6l2xs9.cloudfront.net/wp-content/uploads/20200630140652/artificial-intelligence-3382507_1280.jpg" alt="Italian Trulli">
      </div>
      <div class="col-sm">
        <img src="https://cdn.pixabay.com/photo/2020/04/30/17/50/network-5113917_960_720.jpg" alt="Italian Trulli">
      </div>
    </div>
    
    <div class="table-responsive-sm">
    <table class="table table-primary">
        <thead>
          <tr>
            <th class="notesh" *ngFor ="let header of headers">{{header.label}}</th>
                      
           </tr>
        </thead>
        <tbody>
          <tr *ngFor = "let record of data">
           <td *ngFor = "let header of headers" >
            <a [href]="record.link" mat-raised-button color='accent' *ngIf="record[header.key] == 'Download'">
                {{record[header.key]}}
            </a>
            <div class="chapter-title" *ngIf="record[header.key] != 'Download'">{{record[header.key]}}</div>
            </td>
          </tr>          
        </tbody>
      </table>
    </div>

    <div class="table-responsive-sm">
        <table class="table table-primary">
            <thead>
              <tr>
                <th class="notesh" *ngFor ="let header2 of headers2">{{header2.label}}</th>
                          
               </tr>
            </thead>
            <tbody>
              <tr *ngFor = "let record of items">
               <td *ngFor = "let header2 of headers2" >
                <a [href]="record.link" mat-raised-button color='accent'*ngIf="record[header2.key] == 'Download'">
                    {{record[header2.key]}}
                </a>
                <div class="chapter-title" *ngIf="record[header2.key] != 'Download'">{{record[header2.key]}}</div>
                </td>
              </tr>          
            </tbody>
          </table>
        </div>
        